import cn from "./cn";

export default function StatusPill({ status }) {
  const cls =
    status === "ASSIGNED"
      ? "bg-blue-50 text-blue-700 border-blue-200"
      : status === "UNASSIGNED"
      ? "bg-amber-50 text-amber-700 border-amber-200"
      : "bg-slate-50 text-slate-700 border-slate-200";
  return <span className={cn("text-[11px] px-2 py-1 rounded-full border", cls)}>{status}</span>;
}